{
    "LicenceManagementPage_Title": "Gestione delle licenze",
    "LicenceManagementPage_Subtitle": "Gestisci le assegnazioni di dispositivi e utenti per un ambito telefonico selezionato.",
    "LicenceManagementPage_Tile_Analytics": "Analisi CX",
    "LicenceManagementPage_Tile_Score": "Punteggio CX",
    "LicenceManagementPage_Tile_Record": "Record CX",
    "LicenceManagementPage_Tile_Integration": "Integrazione CX",
    "LicenceManagementPage_Tile_Licences": "Licenze",
    "LicenceManagementPage_Column_DeviceNumber": "Dispositivo",
    "LicenceManagementPage_Column_Username": "Nome utente",
    "LicenceManagementPage_Column_Email": "E-mail",
    "LicenceManagementPage_Column_HasDevice": "Dispositivo",
    "LicenceManagementPage_Column_Agent": "Agente",
    "LicenceManagementPage_Column_WelcomeEmail": "Email di benvenuto",
    "LicenceManagementPage_Column_Licences": "Licenze",
    "LicenceManagementPage_Column_Actions": "Azioni",
    "LicenceManagementPage_Type_Device": "Dispositivo",
    "LicenceManagementPage_Type_User": "Utente",
    "LicenceManagementPage_Popup_TelSys": "Server di telefonia",
    "LicenceManagementPage_Popup_Partition": "Partizione",
    "LicenceManagementPage_Popup_Device": "Dispositivo",
    "LicenceManagementPage_Popup_Username": "Nome utente",
    "LicenceManagementPage_Popup_Email": "E-mail",
    "LicenceManagementPage_Popup_Close": "Vicino",
    "LicenceManagementPage_LicencePopup_Title": "Gestisci le licenze dei prodotti",
    "LicenceManagementPage_LicencePopup_Licence": "Licenza",
    "LicenceManagementPage_LicencePopup_ScoreUserCalls": "Assegnazione punteggi alle chiamate degli utenti",
    "LicenceManagementPage_LicencePopup_RecordUserCalls": "Registrazione delle chiamate degli utenti",
    "LicenceManagementPage_LicencePopup_IntegrationEnabled": "Abilitato",
    "LicenceManagementPage_LicencePopup_On": "SU",
    "LicenceManagementPage_LicencePopup_Off": "Spento",
    "LicenceManagementPage_LicencePopup_Enabled": "Abilitato",
    "LicenceManagementPage_LicencePopup_Disabled": "Disabile",
    "LicenceManagementPage_LicencePopup_EmailRequired": "Aggiungi un indirizzo email prima di salvare le modifiche alla licenza per questo dispositivo.",
    "LicenceManagementPage_Email_AddTooltip": "Fai clic per aggiungere l'indirizzo email e creare l'utente",
    "LicenceManagementPage_EssentialsExtension": "Elementi essenziali (Estensione)",
    "LicenceManagementPage_Empty": "Nessun risultato trovato qui",
    "LicenceManagementPage_WelcomeEmail_Title": "Reinvia l'email di benvenuto a \"{}\"",
    "LicenceManagementPage_WelcomeEmail_Confirm": "Desideri reinviare l'email di benvenuto a \"{}\"?",
    "LicenceManagementPage_WelcomeEmail_Success": "L'e-mail è stata inviata correttamente a \"{}\"",
    "LicenceManagementPage_WelcomeEmail_Fail": "Si è verificato un errore imprevisto durante l'invio dell'e-mail. Riprova.",
    "LicenceManagementPage_Licence_SaveFailed": "Impossibile leggere le impostazioni correnti dell'utente, pertanto le licenze non sono state salvate. Riprova.",
    "LicenceManagementPage_Column_LicencesCount": "[{} Licenze]",
    "LicenceManagementPage_Tick_Save": "Salva le modifiche alla riga",
    "LicenceManagementPage_Tick_InvalidEmail": "Inserisci un indirizzo email valido per creare l'utente.",
    "LicenceManagementPage_Licence_ScoringEnabled": "Punteggio abilitato",
    "LicenceManagementPage_Licence_RecordingEnabled": "Registrazione abilitata",
    "LicenceManagementPage_Licence_WithScoring": "{} + Punteggio",
    "LicenceManagementPage_Licence_WithRecording": "{} + Registrazione",
    "LicenceManagementPage_Username_NoUserTooltip": "Questo verrà utilizzato come nome utente quando verrà creato un nuovo utente.",
    "NAME": "Lingua della pagina di gestione delle licenze"
}